import { createContext } from 'react';

const nutritionContext = createContext();

export default nutritionContext;
